// extracted by mini-css-extract-plugin
var _1 = "button-vtv6q";
export { _1 as "button" }
